@if (_show) {
  <ng-content />
}
